import { BASE_URL_CGI_GO, BASE_URL_ONLINE_DOCS } from '../../../base/constants/cgi-base';
// 收藏
export var COLLECT = "".concat(BASE_URL_ONLINE_DOCS, "doc_collect");
// 获取收藏状态
export var GET_COLLECT = "".concat(BASE_URL_ONLINE_DOCS, "doc_getcollect");
// 创建文件
export var CREATE_DOC = "".concat(BASE_URL_ONLINE_DOCS, "createdoc_new");
// 文件回收
export var RECOVER = "".concat(BASE_URL_ONLINE_DOCS, "doc_recover");
// 沉淀到列表页
export var DOC_HUMTRANS = "".concat(BASE_URL_ONLINE_DOCS, "doc_humtrans");
// 文档是否可移动文件夹
export var CAN_MOVE = "".concat(BASE_URL_CGI_GO, "can/move");
